import React, { useEffect } from "react";
import {
  CoinflowPurchase,
  Currency,
  CoinflowEnvs,
  OnSuccessMethod,
  PaymentMethods,
} from "@coinflowlabs/react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { EventTypes, ROUTES } from "../../../utils/constants";
import EventDispatcher from "../../../utils/event-dispatcher";
import usePaymentRedirect from "../../../hooks/usePaymentRedirect";
import { PaymentInitiationUrlParams } from "../../../hooks/usePayments";
import "./Coinflow.scss";

enum CoinflowPaymentUrlParamKeys {
  SESSION_KEY = "sessionKey",
  MERCHANT_ID = "merchantId",
  AMOUNT = "amount",
  REFERENCE = "reference",
  USER_ID = "userId",
  PRODUCT_NAME = "productName",
  PRODUCT_ID = "productId",
  LABEL = "label",
  VALUE = "value",
}

type PaymentUrlParams = {
  [key in CoinflowPaymentUrlParamKeys]: key extends
    | CoinflowPaymentUrlParamKeys.AMOUNT
    | CoinflowPaymentUrlParamKeys.VALUE
    ? number
    : string;
};

const COINFLOW_ENV = process.env.REACT_APP_COINFLOW_ENV;
const REDIRECT_BASE_ROUTE = "/payments/coinflow/confirm";

export default function Coinflow() {
  const navigate = useNavigate();
  const [queryParams] = useSearchParams();
  const { handlePaymentRedirect } = usePaymentRedirect();
  const paymentMethod = queryParams.get(
    PaymentInitiationUrlParams.PAYMENT_METHOD
  );
  const paymentData = atob(
    queryParams.get(PaymentInitiationUrlParams.DATA) ?? ""
  );
  const paymentParams = JSON.parse(paymentData);
  const {
    sessionKey,
    merchantId,
    amount,
    reference,
    userId,
    productName,
    productId,
    label,
    value,
  } = paymentParams as PaymentUrlParams;

  const handlePaymentSuccess: OnSuccessMethod = (data) => {
    let paymentId = data;
    if (typeof data !== "string") {
      paymentId = data.paymentId;
    }
    navigate(
      `${REDIRECT_BASE_ROUTE}?reference=${reference}&paymentId=${paymentId}`
    );
  };

  useEffect(() => {
    const paramValues = Object.values(paymentParams);
    if (paramValues.includes("") || paramValues.includes(null)) {
      EventDispatcher.dispatch(EventTypes.PAYMENTS.ERROR, {
        message: "Invalid payment URL",
      });
      handlePaymentRedirect(ROUTES.WALLET.TOPUP_FAILED);
    }
  }, [paymentParams, handlePaymentRedirect]);

  return (
    <div className="MobileOnly CoinflowContainer">
      <CoinflowPurchase
        sessionKey={sessionKey}
        merchantId={merchantId}
        env={COINFLOW_ENV as CoinflowEnvs | undefined}
        onSuccess={(...args) => handlePaymentSuccess(...args)}
        allowedPaymentMethods={
          paymentMethod && paymentMethod !== PaymentMethods.card
            ? [paymentMethod as PaymentMethods]
            : undefined
        }
        subtotal={{
          currency: Currency.USD,
          cents: +amount * 100,
        }}
        webhookInfo={{
          reference: reference,
          userId: userId,
        }}
        chargebackProtectionData={[
          {
            productName: productName,
            productType: "gameOfSkill",
            quantity: 1,
            rawProductData: {
              productID: productId,
              productDescription: "An entry to game",
              label,
              value,
            },
          },
        ]}
      />
    </div>
  );
}
